import { createPortal } from 'react-dom';
import c from './bottom-sheet.module.scss';

const BottomSheet = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return createPortal(
    <div className={c.backdrop} onClick={handleBackdropClick}>
      <div className={c.bottomSheet}>
        <div className={c.content}>{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default BottomSheet;
